import { render, staticRenderFns } from "./ModifyProjectForm.vue?vue&type=template&id=7540afa6"
import script from "./ModifyProjectForm.vue?vue&type=script&lang=js"
export * from "./ModifyProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports